module.exports = __webpack_public_path__ + "img/pagos.dc5ae9f6.jpg";